import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=5ac2733d&scoped=true"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"
import style0 from "./addRole.vue?vue&type=style&index=0&id=5ac2733d&prod&lang=scss&scoped=true"
import style1 from "./addRole.vue?vue&type=style&index=1&id=5ac2733d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2733d",
  null
  
)

export default component.exports